import { Component, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as FileSaver from "file-saver";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ReportsService } from "../../../../core/services/reports.service";
import { CommonModule } from "@angular/common";
import { TableFilterEvent, TableModule } from "primeng/table";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { GetOpenClientCreditsResponse } from "../../../../core/models/reports/getOpenClientCreditsResponse";
import { LoaderService } from "../../../../core/services/loader.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { PdfViewerPageComponent } from "../../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";

@Component({
  selector: "jni-open-client-credits",
  templateUrl: "./open-client-credits.component.html",
  styleUrls: ["./open-client-credits.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    DateFilterComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
  ],
})
export class OpenClientCreditsComponent implements OnInit {
  openClientCreditsResponseLists: GetOpenClientCreditsResponse[] = [];
  openClientCreditsResponseFilteredList: GetOpenClientCreditsResponse[] = [];
  filteredDataOpenClientCreditsResponseLists: GetOpenClientCreditsResponse[] =
    [];
  descriptionCharacterCond = false;

  clientId = "";
  orderDisplayModal = false;
  clientDisplayModal = false;
  saleOrderId = "";

  dateColumn = "invoiceDate";
  totalAmountNotSettled = 0;
  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _reportsService: ReportsService,
    private _dashboardService: DashboardService,
    private _aRoute: ActivatedRoute,
    private renderer: Renderer2
  ) {
    this._aRoute.params.subscribe(params => {
      this.clientId = params["customerAccount"];
    });
  }

  ngOnInit(): void {
    this.getopenClientCreditsReportDetail();
  }

  getopenClientCreditsReportDetail(): void {
    this._loaderService.setLoaderState(true);
    this._reportsService.getOpenClientCreditsReport().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.openClientCreditsResponseLists = res.data;
          this.openClientCreditsResponseFilteredList =
            this.openClientCreditsResponseLists;
          this.filteredDataOpenClientCreditsResponseLists =
            this.openClientCreditsResponseFilteredList;

          this.totalAmountNotSettled =
            this.openClientCreditsResponseLists.reduce(
              (sum, el) => (sum += el.amountNotSettled ?? 0),
              0
            );
        } else {
          this._toastr.error(res.message, "Error");
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  exportExcelFile() {
    this.exportExcelForFilterData(
      this.filteredDataOpenClientCreditsResponseLists
    );
  }
  exportExcelForFilterData(filterclientlist: GetOpenClientCreditsResponse[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Invoice Date"]: datum.invoiceDate,
        ["Invoice Number"]: datum.invoice,
        ["Sales Order"]: datum.salesOrderId,
        ["Project Name"]: datum.projectName,
        ["Customer Number"]: datum.customerAccount,
        ["Customer Name"]: datum.customerName,
        ["Amount not settled"]: datum.amountNotSettled,
        ["Note"]: datum.note,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OpenClientCredits");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  descriptionCharacterCount(obj: string) {
    if (obj && obj?.length > 45) this.descriptionCharacterCond = true;
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  redirectToClient(client: string) {
    if (client) {
      this.clientId = client;
      this.clientDisplayModal = true;
    }
  }

  redirectToSaleorder(saleorder: string) {
    if (saleorder) {
      this.saleOrderId = saleorder;
      this.orderDisplayModal = true;
    }
  }

  getInvoiceReport(invoiceId: string) {
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }

        PdfViewerPageComponent.openInNewTab(res.data, `Invoice-${invoiceId}`);
        // const blob = this.b64toBlob(res.data, "application/pdf");
        // const blobUrl = URL.createObjectURL(blob);
        // window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  applyFilter($event: GetOpenClientCreditsResponse[] | DateFilter) {
    if (Array.isArray($event)) {
      this.openClientCreditsResponseFilteredList = $event;
    }
  }

  clearFilter($event: GetOpenClientCreditsResponse[] | DateFilter) {
    if (Array.isArray($event)) {
      this.openClientCreditsResponseFilteredList = $event;
    }
  }

  onFilter(event: TableFilterEvent) {
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.filteredDataOpenClientCreditsResponseLists = event.filteredValue;
    } else {
      this.filteredDataOpenClientCreditsResponseLists =
        this.openClientCreditsResponseFilteredList;
    }

    // As per the ticket 12162 totals will show on filters
    this.totalAmountNotSettled =
      this.filteredDataOpenClientCreditsResponseLists.reduce(
        (sum, el) => (sum += el.amountNotSettled ?? 0),
        0
      );
  }
}
